export const ColorfulBorder = () => {
  return (
    <div className="h-3 w-full bg-repeat-x bg-[url('https://images.ctfassets.net/0sea1vycfyqy/7vcAmWLK2EbtrwRT3rUVzT/4a14d7ca471f89474a14f4f010a5995d/Group_1030.png')] lg:bg-[url('https://images.ctfassets.net/0sea1vycfyqy/4RvkJdOREUJIafOgamNMFi/7a2e197ce1040484fac23e3fbbd1b003/New_Border.png')] lg:h-6 lg:bg-cover" />
  );
};
